"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const richText = require("../types/value/richText.cjs");
const RichTextReversedNodeType = {
  [richText.RichTextNodeType.listItem]: "listItem",
  [richText.RichTextNodeType.oListItem]: "oListItem",
  [richText.RichTextNodeType.list]: "list",
  [richText.RichTextNodeType.oList]: "oList"
};
exports.RichTextReversedNodeType = RichTextReversedNodeType;
//# sourceMappingURL=types.cjs.map
